import { render, staticRenderFns } from "./huodongjiangpin.vue?vue&type=template&id=ee6102e8"
import script from "./huodongjiangpin.vue?vue&type=script&lang=js"
export * from "./huodongjiangpin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports